import React from 'react';
import {temCertificado} from '../../../view/formulario/actions/FormBuilderActions'
import {View} from 'react-template'

export default class Visualizar extends View {

    componentWillMount(){
        this.hasCertifiel()
    }

    componentWillUnmount(){
        this.removeTab()
    }

    setTabsForm(hasCertifiel){

        const tabs = [
            {to:`/admin/formulario/${this.props.params.id}`,text:'Detalhar'},
            {to:`/admin/formulario/${this.props.params.id}/inscritos`,text:'Inscritos'},
            {to:`/admin/formulario/${this.props.params.id}/certificado`,text:'Dados do Certificado'}
        ]
        if(!hasCertifiel) delete tabs[2]

        this.setTabOptions(tabs);
    }

    setTabsGRU(){
        const tabs = [
            {to:`/admin/gru/${this.props.params.id}`,text:'Detalhar'},
            {to:`/admin/gru/${this.props.params.id}/historico`,text:'Histórico'}
        ]

        this.setTabOptions(tabs);
    }

    hasCertifiel(){
        const path = this.props.location.pathname;
        const idForm = this.props.params.id
        
        // se for GRU ja retorna falso
        if(!path.includes('formulario')){
            return this.setTabsGRU(false)
        }

        temCertificado(idForm, res => {
            if(res.data > -1){
                this.setTabsForm(true)
            } else {
                this.setTabsForm(false)
            }
        },
        error => {
            this.notifyError('Erro ao tentar obeter informações de certificado', '');
        })   
    }

    render() {
        // base da pagina de formularios
        return (
            <div className="width-100">
                <div className='p-t'>                 
                    <div id='show-form'>
                         {this.props.children}
                    </div>                  
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/formbuilder/menu/ShowForm.js